import { use } from 'react';
import { WebSocketContext, WebSocketContextType } from './webSocketContextValue';

export const useWebSocket = (): WebSocketContextType => {
  const context = use(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
};
